import Image from 'next/image';
import AlfaGptMenuIcon from './Icons/AlfaGptMenuIcon';
import { useTranslation } from '@/lib/i18n';
import { AgentPlaceHolder } from './DeepSearch/thinking/ThinkTaskCardList';
import { useTheme } from 'next-themes';

const MessageBoxLoading = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-3">
        <div className="flex gap-4 items-start relative">
          {/* Pythra Tab */}
          <div className="relative">
            <button className="flex gap-2 h-9 items-center px-2 py-1 rounded-[8px] transition-all text-text-primary">
              <AlfaGptMenuIcon size={16} />
              <span className="text-[16px]">{t('Pythra')}</span>
            </button>
            <div className="absolute bottom-[-12px] left-0 right-0 h-[3px] bg-bg-main" />
          </div>
        </div>

        {/* Horizontal divider line */}
        <div className="h-px bg-bg-main w-full" />
      </div>
      <div className="py-4 mt-4">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            {/* <Image src="/logo_white.svg" width={16} height={16} alt="Pythra Search" /> */}
            <div className="animate-spin-slow">
              <Image src="/logo.svg" width={20} height={13} alt="Logo" />
            </div>
            <div className="text-sm text-white">
              <span
                className="font-medium bg-clip-text text-transparent animated-gradient-flow"
                style={{
                  backgroundImage:
                    theme !== 'dark'
                      ? 'linear-gradient(87.32deg, #4B5563 1.12%, #6B7280 28.93%, #1F2937 52.94%, #6B7280 70.34%, #4B5563 100%)'
                      : 'linear-gradient(87.32deg, #717171 1.12%, #999999 28.93%, #FFFFFF 52.94%, #999999 70.34%, #6D6C6C 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {t('Pythra Research is assigning tasks to multiple agents...')}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="relative w-full flex flex-col">
        <AgentPlaceHolder />
      </div>
    </div>
  );
  // return (
  //   <div className="flex flex-col space-y-2 w-full lg:w-9/12 bg-bg-main animate-pulse rounded-lg mt-3 pb-3">
  //     <div className="h-3 rounded-full w-full bg-bg-card" />
  //     <div className="h-3 rounded-full w-9/12 bg-bg-card" />
  //     <div className="h-3 rounded-full w-10/12 bg-bg-card" />
  //   </div>
  // );
};

export default MessageBoxLoading;

export function AlfaChatRouteLoading() {
  return (
    <div className="flex flex-col space-y-2 w-full lg:w-9/12 bg-bg-main animate-pulse rounded-lg mt-3 pb-3">
      <div className="h-3 rounded-full w-full dark:bg-[#1E1E1E] bg-[#e9e9e9]" />
      <div className="h-3 rounded-full w-9/12 dark:bg-[#1E1E1E] bg-[#e9e9e9]" />
      <div className="h-3 rounded-full w-10/12 dark:bg-[#1E1E1E] bg-[#e9e9e9]" />
    </div>
  );
}

export const ChatRouteLoading = ({
  width = 60,
  height = 60,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <div className="inline-flex items-center justify-center">
      <Image
        src="/logo.svg"
        width={width}
        height={height}
        alt="loading"
        className="animate-spin-slow"
      />
    </div>
  );
};
